import LoginForm from "../Components/LoginForm/LoginForm";

const SignUp = () => {
  return (
    <LoginForm cardName="Sign Up" isSignUp={true} cardStyle="my-9"></LoginForm>
  );
};

export default SignUp;
